<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('attach_note') }}

        v-card-text.pa-0
          v-container.white.pa-0(style="max-width:600px")
            div.px-4.py-3
              v-btn.button-Aa-medium.info500--text.px-0(color="transparent" text small height="24" @click="clickAddNewNotes")
                v-icon(left size="20") mdi-plus
                | {{ $t('new_note') }}
            v-divider.basic300
            div.pa-4
              v-text-field(v-model="searchText" placeholder='Search note' hide-details dense outlined height="40" background-color="basic200")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.pa-0(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="notes.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('notes_not_found') }}
              div(v-else)
                template(v-for="(note, index) in notes")
                  v-card(flat @click="clickNote(note, index)")
                    v-row.px-4.py-3(no-gutters)
                      v-col
                        div.p1.basic800--text.mb-1 {{ note.name }}
                        div.c1.basic600--text.mb-1 {{ note.extra_info }}
                        div.c2.basic600--text.mb-1 {{ note.format.replace('_', ' ') }}
                      v-col.shrink.align-self-center
                        y-checkbox.ma-0.pa-0(v-model="note.selected" readonly)
                  v-divider.basic300

              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'AttachNotes',
  props: {
    open: {
      type: Boolean
    },
    initialNotes: {
      type: Array,
      default: () => ([])
    }
  },
  components: { ShowMoreText },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    // totalPage: 1,
    count: 0,
    notes: [],
    selectedNotes: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page(val) {
      if (!this.isFetching) {
        this.fetchNotes(val)
      }
    },
    searchText() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted() {
    this.selectedNotes = [...this.initialNotes]
    this.fetchNotes(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    clickNote(note, index) {
      this.notes[index].selected = !this.notes[index].selected
      this.updateNote(this.notes[index])
    },
    updateNote(note) {
      if (note.selected) {
        this.addNote(note)
      } else {
        this.removeNote(note)
      }
    },
    addNote(note) {
      this.selectedNotes.push(note.item)
    },
    removeNote(note) {
      this.selectedNotes = this.selectedNotes.filter(x => x.id !== note.id)
    },
    getSelected(note) {
      let selnote = this.selectedNotes.filter(f => f.id === note.id)
      if (selnote.length > 0) {
        return true
      }
      return false
    },
    fetchNotes(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/product_notes/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios.get(fetchUrl)
        .then(response => {
          this.isFetching = false
          this.notes = response.data.results.map(m => { return { ...m, item: m, selected: this.getSelected(m) }})
          this.count = response.data.count
        })
        .catch(() => {})
    },
    searchItem() {
      let searchUrl = `/product_notes/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then(response => {
          this.isFetching = false
          this.notes = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    clickDone() {
      this.$emit('updateNotes', this.selectedNotes)
      this.showModal = false
    },
    clickAddNewNotes () {
      this.$emit('addNewNote')
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "attach_note": "Attach note",
    "new_note": "New note",
    "notes_not_found": "Notes not found or empty"
  },
  "id": {
    "attach_note": "Tetapkan nota",
    "new_note": "nota baru",
    "notes_not_found": "Tiada Nota"
  }
}
</i18n>
